import React, { useState, useMemo } from "react";
import RecentMission from "./RecentMission/RecentMission";
import "./RecentMissionsDisplay.css";
// ReactOptimizer supprimé

const RecentMissionsDisplay = ({ recentMissions }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [useVirtualization, setUseVirtualization] = useState(true);
  const missionsPerPage = 20;

  // Validation et sécurisation des données
  const safeMissions = Array.isArray(recentMissions) ? recentMissions : [];

  // Décision sur le mode de rendu
  const shouldVirtualize = safeMissions.length > 50 && useVirtualization;
  const needsPagination = !shouldVirtualize && safeMissions.length > missionsPerPage;

  // Rendu optimisé avec memoization
  const renderMission = useMemo(() => (mission, index) => (
    <RecentMission key={mission.id || index} mission={mission} />
  ), []);

  // Calcul des missions à afficher selon le mode
  const currentMissions = needsPagination ? 
    safeMissions.slice((currentPage - 1) * missionsPerPage, currentPage * missionsPerPage) : 
    safeMissions;
  const totalPages = needsPagination ? Math.max(1, Math.ceil(safeMissions.length / missionsPerPage)) : 1;

  const handleNextPage = () => {
    if (needsPagination && currentPage < totalPages && safeMissions.length > 0) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (needsPagination && currentPage > 1 && safeMissions.length > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="recent-missions-display">
        <h2>Résultats de la recherche</h2>
        {safeMissions.length === 0 ? (
          <div className="no-results">
            <p>Aucune mission récente trouvée. Veuillez ajuster vos critères de recherche.</p>
          </div>
        ) : (
          <>
            {/* Informations et contrôles de performance */}
            <div style={{ 
              marginBottom: '15px', 
              padding: '10px', 
              backgroundColor: shouldVirtualize ? '#e8f5e8' : '#f8f9fa', 
              borderRadius: '4px',
              fontSize: '0.9rem',
              color: '#495057',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span>
                {shouldVirtualize 
                  ? `🚀 ${safeMissions.length} missions (mode virtualisé)`
                  : needsPagination 
                    ? `Affichage de ${((currentPage - 1) * missionsPerPage) + 1} à ${Math.min(currentPage * missionsPerPage, safeMissions.length)} sur ${safeMissions.length} missions`
                    : `${safeMissions.length} mission(s) trouvée(s)`
                }
              </span>
              {safeMissions.length > 50 && (
                <button 
                  onClick={() => setUseVirtualization(!useVirtualization)}
                  style={{ 
                    padding: '4px 8px', 
                    fontSize: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '3px',
                    background: shouldVirtualize ? '#4caf50' : '#f0f0f0',
                    color: shouldVirtualize ? 'white' : '#333',
                    cursor: 'pointer'
                  }}
                >
                  {shouldVirtualize ? '📄 Pagination' : '🚀 Virtualiser'}
                </button>
              )}
            </div>
            
            {/* Rendu classique */}
            <div className="missions-grid">
              {currentMissions.map((mission, index) => (
                <RecentMission key={mission.id || index} mission={mission} />
              ))}
            </div>
            
            {/* Pagination seulement en mode classique */}
            {needsPagination && (
              <div className="pagination-controls">
                <button 
                  onClick={handlePrevPage} 
                  disabled={currentPage === 1}
                  className="pagination-button"
                >
                  ←
                </button>
                <span className="page-indicator">
                  Page {currentPage} sur {totalPages}
                </span>
                <button 
                  onClick={handleNextPage} 
                  disabled={currentPage === totalPages}
                  className="pagination-button"
                >
                  →
                </button>
              </div>
            )}

            {/* Debug info en développement */}
            {process.env.NODE_ENV === 'development' && (
              <div style={{
                position: 'fixed',
                bottom: '50px',
                right: '10px',
                background: 'rgba(0,0,0,0.8)',
                color: 'white',
                padding: '8px',
                borderRadius: '4px',
                fontSize: '12px',
                zIndex: 1000
              }}>
                Missions: {safeMissions.length} | {shouldVirtualize ? 'Virtualisé' : 'Pagination'}
              </div>
            )}
          </>
        )}
      </div>
  );
};

export default RecentMissionsDisplay; 